<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button" class="active">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>          
          <li v-if="local != 'jp' && IsTester">
            <router-link :to="{ name: 'MemberCoupon' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("優惠專區") }}
            </router-link>
          </li>
          <li v-if="local != 'jp' && IsTester && hasInvite">
            <router-link :to="{ name: 'InvitEvent' }" tag="button">
              <img src="img/member_icon_friends.svg" alt="" />
              {{ $t("邀請朋友") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box" style="margin-bottom: 20px">
            <ul class="text-box">
              <li class="title-box">
                <div class="box">
                  <div>{{ $t("我的套票") }}</div>
                </div>
                <div class="box">
                  <router-link :to="{ name: 'DonateTicket' }" tag="button">
                    {{ $t("受贈票卡") }}
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
          <template v-if="Subscription">
            <!-- 新增 -->
            <div class="bg-box">
              <ul class="text-box">
                <li class="title-box">
                  <div class="subscription">訂閱資訊</div>
                  <div class="box order-btn" v-if="Subscription.Status == 1">
                    <button class="" @click="cancalSubscription()">取消訂閱</button>
                  </div>
                </li>
                <hr>
                <li>
                  <div>開始訂閱時間</div>
                  <div>{{ Subscription.CreateTime }}</div>
                </li>
                <li>
                  <div>最後一次付款時間</div>
                  <div>{{ Subscription.LastPayTime }}</div>
                </li>
                <li>
                  <div>預計下次付款時間</div>
                  <div>{{ Subscription.NextPayTime }}</div>
                </li>
                <li class="period_box">
                  <div>目前期數</div>
                  <div><span>{{ Subscription.PaidInstallments }}</span> / <span>{{ Subscription.TotalInstallments
                  }}</span></div>
                </li>
              </ul>
            </div>
            <hr>
          </template>
          <div v-for="(Order, index) in Orders" :key="Order.OId">
            <hr v-if="index != 0" />
            <div class="bg-box">
              <ul class="text-box">
                <li>
                  <div>{{ $t("訂單編號") }}</div>
                  <div class="box">
                    <div>{{ Order.OrderId }}</div>
                    <!-- 0610 按鈕 刪除連結 新增span -->
                    <button :id="'btn-order-' + Order.OId" class="btn-more" v-if="Order.ProductType != 3"
                      @click="openDetail('btn-order-' + Order.OId)">
                      {{ $t("查看") }} <span>﹀</span>
                    </button>
                  </div>
                </li>
                <hr />
                <li>
                  <div>{{ $t("商品名稱") }}</div>
                  <!-- 0610 新增 p -->
                  <div v-if="Order.ProductType == 1">
                    {{ Order.Product.Name }}
                    <p>{{ $t("時數票") }}</p>
                  </div>
                  <div v-if="Order.ProductType == 2">
                    {{ Order.o_maas_pt_det.o_maas_pt_name_zh_tw }}
                    <p>{{ $t("天數票") }}</p>
                  </div>
                  <div v-if="Order.ProductType == 3">
                    {{ Order.ProductPoint.Name }}
                    <p>{{ $t("點數商品") }}</p>
                  </div>
                </li>
                <li>
                  <div>{{ $t("建立時間") }}</div>
                  <div>
                    {{ timeString(Order.CreateTime, "YYYY/MM/DD HH:mm:ss") }}
                  </div>
                </li>
              </ul>
              <ul class="text-box content" v-if="Order.ProductType == 1">
                <hr />
                <li>
                  <div>{{ $t("狀態") }}</div>
                  <div v-if="Order.Status == -1">{{ $t("未付款") }}</div>
                  <div v-if="Order.Status == 1">{{ $t("已付款") }}</div>
                  <div v-if="Order.Status == 99">{{ $t("已退款") }}</div>
                </li>
                <li>
                  <div>{{ $t("張數") }}</div>
                  <div class="box ticket-number">
                    ${{ Order.Amount }} x {{ Order.Count }}{{ $t("張") }}
                    <button :id="'ticket-' + Order.OId" @click="openTickerDetail('ticket-' + Order.OId)">
                      <span>﹀</span>
                    </button>
                  </div>
                </li>
                <hr class="divider" />
                <li class="detail-box">
                  <ul class="detail">
                    <li>
                      <div>{{ $t("使用中") }}</div>
                      <div>{{ Order.TotalUsing }}{{ $t("張") }}</div>
                    </li>
                    <li>
                      <div>{{ $t("已失效") }}</div>
                      <div>{{ Order.TotalExpired }}{{ $t("張") }}</div>
                    </li>
                    <li>
                      <div>{{ $t("轉贈中") }}</div>
                      <div>{{ Order.TotalDonating }}{{ $t("張") }}</div>
                    </li>
                    <li>
                      <div>{{ $t("已轉贈") }}</div>
                      <div>{{ Order.TotalDonate }}{{ $t("張") }}</div>
                    </li>
                    <li>
                      <div>{{ $t("已退款") }}</div>
                      <div>{{ Order.TotalRefunded }}{{ $t("張") }}</div>
                    </li>
                    <hr class="divider" />
                  </ul>
                </li>
                <li>
                  <div>{{ $t("總金額") }}</div>
                  <div>${{ Order.TotalAmount }}</div>
                </li>
                <hr />
                <li class="box order-btn">
                  <router-link :to="{
                    name: 'OrderInfo',
                    params: { OrderId: Order.OrderId },
                  }" tag="button">
                    {{ $t("訂單詳情") }}
                  </router-link>
                </li>
              </ul>
              <ul class="text-box content" v-if="Order.ProductType == 2">
                <hr />
                <li>
                  <div>{{ $t("狀態") }}</div>
                  <div v-if="Order.Status == -1">{{ $t("未付款") }}</div>
                  <div v-if="
                    Order.Status == 1 &&
                    !Order.o_maas_so_mstr.o_maas_so_rf_ing
                  ">
                    {{ $t("已付款") }}
                  </div>
                  <div v-if="
                    Order.Status == 1 && Order.o_maas_so_mstr.o_maas_so_rf_ing
                  ">
                    {{ $t("申請退款") }}
                  </div>
                  <div v-if="Order.Status == 99">{{ $t("已退款") }}</div>
                </li>
                <li>
                  <div>{{ $t("總金額") }}</div>
                  <div>${{ Order.TotalAmount }}</div>
                </li>
                <li>
                  <div>{{ $t("剩餘點數") }}</div>
                  <div>
                    {{
                      Order.o_maas_so_mstr.o_maas_so_ret_bonus -
                      Order.o_maas_so_mstr.o_maas_so_used_bonus
                    }}
                  </div>
                </li>
                <li>
                  <div>{{ $t("使用效期") }}</div>
                  <div>
                    {{
                      timeString(
                        Order.o_maas_so_mstr.o_maas_so_start,
                        "YYYY/MM/DD"
                      )
                    }}
                    ~
                    {{
                      timeString(
                        Order.o_maas_so_mstr.o_maas_so_expire,
                        "YYYY/MM/DD"
                      )
                    }}
                  </div>
                </li>
                <hr />
                <li class="box order-btn">
                  <router-link :to="{
                    name: 'OrderInfo',
                    params: { OrderId: Order.OrderId },
                  }" tag="button">
                    {{ $t("訂單詳情") }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <section class="page" v-if="pageAll > 1">
            <div class="container">
              <paginate :no-li-surround="false" :page-count="pageAll" :page-range="5" :margin-pages="1"
                :click-handler="loadList" :prev-text="'<'" :next-text="'>'" :prev-link-class="'Prev'"
                :next-link-class="'next'" :container-class="''" :page-link-class="''" :active-class="'page-active'"
                :hide-prev-next="false">
              </paginate>
            </div>
          </section>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Paginate from "vuejs-paginate";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.component("paginate", Paginate);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "訂單編號": "訂單編號",
    "查看": "查看",
    "商品名稱": "商品名稱",
    "時數票": "時數票",
    "天數票": "天數票",
    "點數商品": "點數商品",
    "建立時間": "建立時間",
    "狀態": "狀態",
    "未付款": "未付款",
    "已付款": "已付款",
    "已退款": "已退款",
    "張數": "張數",
    "張": "張",
    "使用中": "使用中",
    "已失效": "已失效",
    "轉贈中": "轉贈中",
    "已轉贈": "已轉贈",
    "總金額": "總金額",
    "訂單詳情": "訂單詳情",
    "申請退款": "申請退款",
    "剩餘點數": "剩餘點數",
    "使用效期": "使用效期",
    "錯誤": "錯誤",
    "取得訂單過程發生錯誤, 請稍後再試一次": "取得訂單過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "受贈票卡": "受贈票卡",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "訂單編號": "Order number",
    "查看": "View",
    "商品名稱": "Name",
    "時數票": "Hour pass",
    "天數票": "Monthly/Weekly pass",
    "點數商品": "Bonus product",
    "建立時間": "Time",
    "狀態": "Status",
    "未付款": "Not paid",
    "已付款": "Paid",
    "已退款": "Refunded",
    "張數": "Amount of pass",
    "張": "Quantity",
    "使用中": "In use",
    "已失效": "Expired",
    "轉贈中": "Transferring",
    "已轉贈": "Transferred",
    "總金額": "Total",
    "訂單詳情": "Order details",
    "申請退款": "Apply for refund",
    "剩餘點數": "Remaining points",
    "使用效期": "Validity",
    "錯誤": "Error",
    "取得訂單過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "受贈票卡": "Received",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "マイページ",
    "我的套票": "購入/予約履歴",
    "卡片資料": "カード情報",
    "套票兌換": "チケット引き換え",
    "卡片交易記錄": "カード取引履歴",
    "其他資訊": "その他の情報",
    "訂單編號": "注文番号",
    "查看": "もっと見る",
    "商品名稱": "商品の名前",
    "時數票": "フリーパス",
    "天數票": "天數票",
    "點數商品": "點數商品",
    "建立時間": "購入日時",
    "狀態": "状態",
    "未付款": "未払い",
    "已付款": "お支払い済み",
    "已退款": "既に返金されました",
    "張數": "枚数",
    "張": "枚",
    "使用中": "使用中",
    "已失效": "期限切れ",
    "轉贈中": "転送中",
    "已轉贈": "転送済みです",
    "總金額": "お支払い総額",
    "訂單詳情": "注文詳細",
    "申請退款": "払いもどし申請",
    "剩餘點數": "剩餘點數",
    "使用效期": "有効期間",
    "錯誤": "エラー",
    "取得訂單過程發生錯誤, 請稍後再試一次": "購入手続き中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "受贈票卡": "ギフトカード",
    "卡片交易紀錄": "カード取引履歴",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "OrderList",
  i18n,
  data() {
    return {
      Orders: [],
      pageAll: 0,
      perPage: 3,
      local: "zh_tw",
      IsTester: false,
      hasInvite: false,
      Subscription: null,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/OrderList",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得訂單過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        that.IsTester = res.IsTester ? res.IsTester : false;
        that.hasInvite = res.hasInvite ? res.hasInvite : false;
        that.Subscription = res.Subscription ? res.Subscription : null;
        // 判斷結果
        if (res.ok) {
          // 僅做登入驗證
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    this.loadList(1);
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-order");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/_OrderList",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          page: page,
          perPage: this.perPage,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.Orders = res.Orders;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            window.pageYOffset = 0;
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
      });
    },
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    openDetail(id) {
      console.log("1");
      $("#" + id)
        .children()
        .toggleClass("spanadd");
      $("#" + id)
        .parents(".text-box")
        .next(".content")
        .toggleClass("contentadd");
      $("#" + id)
        .parents(".text-box")
        .next(".content")
        .children(".detail-box")
        .removeClass("detail-boxadd");
    },
    openTickerDetail(id) {
      console.log("2");
      $("#" + id)
        .children()
        .toggleClass("spanadd");
      $("#" + id)
        .parents("li")
        .siblings(".detail-box")
        .toggleClass("detail-boxadd");
    },
    cancalSubscription: function () {
      let that = this;
      that
        .$swal({
          heightAuto: false,
          icon: "warning",
          title: "請注意!",
          html: that.$t(
            "請注意！停止訂閱並非進行退款，若需退款請於下方訂單中選擇要退款的項目，確認停止訂閱，請輸入CANCEL後按下送出。"
          ),
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: that.$t("送出"),
          cancelButtonText: that.$t("取消"),
          input: "text",
          inputValidator: (value) => {
            return new Promise((resolve) => {
              if (value != "CANCEL") {
                resolve(that.$t("請輸入CANCEL後再按下送出"));
              } else {
                resolve();
              }
            });
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            // 顯示請稍候
            that.$swal({
              heightAuto: false,
              title: that.$t("請稍候..."),
              allowOutsideClick: false,
              showConfirmButton: false,
              willOpen: function () {
                that.$swal.showLoading();
              },
            });
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/CancelSubscription",
              type: "post",
              data: {
                token: Storage.get("ek_login_token"),
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("取消訂閱成功"),
                    showConfirmButton: false,
                    timer: 3000,
                    allowOutsideClick: false,
                    didDestroy: () => {
                      // 重新整理畫面
                      location.reload();
                    },
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/OrderList.vue